
      import '@folkjs/labs/standalone/folk-reorderable';

      // Make canvases drawable
      document.querySelectorAll('canvas').forEach((canvas) => {
        const ctx = canvas.getContext('2d');
        let isDrawing = false;
        let lastX = 0;
        let lastY = 0;

        // Set up drawing context
        ctx.strokeStyle = '#333';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        function getMousePos(e) {
          const rect = canvas.getBoundingClientRect();
          return {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
          };
        }

        function startDrawing(e) {
          isDrawing = true;
          const pos = getMousePos(e);
          lastX = pos.x;
          lastY = pos.y;
        }

        function draw(e) {
          if (!isDrawing) return;

          const pos = getMousePos(e);
          ctx.beginPath();
          ctx.moveTo(lastX, lastY);
          ctx.lineTo(pos.x, pos.y);
          ctx.stroke();

          lastX = pos.x;
          lastY = pos.y;
        }

        function stopDrawing() {
          isDrawing = false;
        }

        // Mouse events
        canvas.addEventListener('mousedown', startDrawing);
        canvas.addEventListener('mousemove', draw);
        canvas.addEventListener('mouseup', stopDrawing);
        canvas.addEventListener('mouseout', stopDrawing);

        // Touch events for mobile
        canvas.addEventListener('touchstart', (e) => {
          e.preventDefault();
          const touch = e.touches[0];
          const mouseEvent = new MouseEvent('mousedown', {
            clientX: touch.clientX,
            clientY: touch.clientY,
          });
          canvas.dispatchEvent(mouseEvent);
        });

        canvas.addEventListener('touchmove', (e) => {
          e.preventDefault();
          const touch = e.touches[0];
          const mouseEvent = new MouseEvent('mousemove', {
            clientX: touch.clientX,
            clientY: touch.clientY,
          });
          canvas.dispatchEvent(mouseEvent);
        });

        canvas.addEventListener('touchend', (e) => {
          e.preventDefault();
          const mouseEvent = new MouseEvent('mouseup', {});
          canvas.dispatchEvent(mouseEvent);
        });
      });
    